var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#b6b9cc}"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15425",
    "data-name": "Group 15425",
    transform: "translate(0 .129)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18234",
    "data-name": "Rectangle 18234",
    width: 36,
    height: 36,
    rx: 16,
    transform: "translate(0 -.129)",
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sun"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11367",
    "data-name": "Path 11367",
    className: "cls-3",
    d: "M11.917 5.667a.917.917 0 0 0 .917-.917V2.917a.917.917 0 1 0-1.833 0V4.75a.917.917 0 0 0 .916.917z",
    transform: "translate(-.917 -.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11368",
    "data-name": "Path 11368",
    className: "cls-3",
    d: "M20.75 11h-1.833a.917.917 0 1 0 0 1.833h1.833a.917.917 0 1 0 0-1.833z",
    transform: "translate(-1.5 -.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11369",
    "data-name": "Path 11369",
    className: "cls-3",
    d: "M5.667 11.917A.917.917 0 0 0 4.75 11H2.917a.917.917 0 1 0 0 1.833H4.75a.917.917 0 0 0 .917-.916z",
    transform: "translate(-.167 -.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11370",
    "data-name": "Path 11370",
    className: "cls-3",
    d: "M6.078 4.977A.927.927 0 0 0 4.8 6.324L6.124 7.6a.937.937 0 0 0 1.329-1.32z",
    transform: "translate(-.376 -.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11371",
    "data-name": "Path 11371",
    className: "cls-3",
    d: "M16.921 7.86a.917.917 0 0 0 .633-.257l1.32-1.274a.917.917 0 0 0-1.237-1.348l-1.32 1.3a.933.933 0 0 0 .605 1.577z",
    transform: "translate(-1.337 -.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11372",
    "data-name": "Path 11372",
    className: "cls-3",
    d: "M11.917 18a.917.917 0 0 0-.917.917v1.833a.917.917 0 1 0 1.833 0v-1.833a.917.917 0 0 0-.916-.917z",
    transform: "translate(-.917 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11373",
    "data-name": "Path 11373",
    className: "cls-3",
    d: "M17.589 16.117a.917.917 0 1 0-1.274 1.32l1.32 1.3a.924.924 0 0 0 1.292-1.32z",
    transform: "translate(-1.336 -1.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11374",
    "data-name": "Path 11374",
    className: "cls-3",
    d: "m6.125 16.119-1.32 1.274a.928.928 0 0 0 1.275 1.348l1.32-1.274a.917.917 0 0 0-1.274-1.32z",
    transform: "translate(-.378 -1.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11375",
    "data-name": "Path 11375",
    className: "cls-3",
    d: "M11.667 8a3.667 3.667 0 1 0 3.667 3.667A3.667 3.667 0 0 0 11.667 8z",
    transform: "translate(-.667 -.667)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightIcon);
export default __webpack_public_path__ + "static/media/LightIcon.199bfcd2.svg";
export { ForwardRef as ReactComponent };